<!-- alignment table -->
<table class="align-table" cellspacing="0" cellpadding="0" align="center">
  <tr>
    <td>&nbsp;</td>
    <td align="center" class="content-table-cell">
      <!-- content table -->
      <table class="content-table" cellspacing="0" cellpadding="0" align="center">
        <tr align="center">
          <td height="36">&nbsp;</td>
        </tr>
        @if (showLogo()) {
          <tr align="center">
            <td>
              <ng-content select="[logo]" />
            </td>
          </tr>
          <tr align="center">
            <td height="36">&nbsp;</td>
          </tr>
        }
        <tr>
          <td>
            <div class="message-box">
              <table class="message-box-table web-rt-email" cellspacing="0" cellpadding="0">
                <tr>
                  <td colspan="3" class="message-vertical-padding"></td>
                </tr>
                <tr>
                  <td class="message-horizontal-padding"></td>
                  <td class="message-box-content">
                    <div class="message-box-header">
                      <ng-content select="[header]" />
                    </div>
                    <div class="message-box-body">
                      <ng-content select="[body]" />
                    </div>
                  </td>
                  <td class="message-horizontal-padding"></td>
                </tr>
                <tr>
                  <td colspan="3" class="message-vertical-padding"></td>
                </tr>
              </table>
            </div>
          </td>
        </tr>
        <tr>
          <td height="16">&nbsp;</td>
        </tr>
        <tr align="center">
          <td>
            <ng-content select="[footer]" />
            <email-margin [height]="28" />
          </td>
        </tr>
      </table>
    </td>
    <td>&nbsp;</td>
  </tr>
</table>
